angular.module('Itao.IndicatorMap').directive('setHintTable', function (d3, mapConfig, IndicatorSetHandling, UtilityService, $compile) {
  'use strict';

  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;

  /**
   *
   * @param listOrIndicator
   * @returns {boolean}
   */
  function isList(listOrIndicator) {
    return listOrIndicator.hasOwnProperty('indicators');
  }

  /**
   *
   * @param district
   * @returns {string}
   */
  function prepareTableHead(district) {
    var headHtml = '<thead><tr><th>'+district.name+'</th><th>Anmerkungen</th></tr></thead>';

    return headHtml;
  }

  /**
   *
   * @param layer
   * @param indicator
   * @param district
   * @returns {string}
   */
  function bodyRowFromDistrict(layer, indicator, district) {
    var description = '-';
    if(layer.descriptions[district] && layer.descriptions[district][indicator.uid] != null) {
      description = layer.descriptions[district][indicator.uid];
    }
    return '<tr><td>'+indicator.name+'</td><td>' + description + '</td></tr>';
  }

  /**
   * @param layer
   * @param indicators
   * @param district
   */
  function prepareTableBody(layer, indicators, district) {
    return indicators.map(function(indicator) {
      return bodyRowFromDistrict(layer, indicator, district);
    });
  }

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'setHintTable.html',
    scope: {
      selectedIndicatorSet: '=',
      layer: '=',
      selectedDistrict: '=',
      config: '='
    },
    link: function (scope, element) {
      var activeDistrict = null;
      function rerender() {
        if(scope.selectedIndicatorSet != null && scope.layer != null) {
          if(!scope.selectedDistrict) scope.selectedDistrict = Object.keys(scope.layer)[0];
          if(!scope.layer.districts[scope.selectedDistrict]) {
            var newDistrict;
            angular.forEach(scope.layer.districts, function(district){
              if(district.key == activeDistrict.key)
                newDistrict = district;
            });

            activeDistrict = newDistrict ? newDistrict : scope.layer.districts[Object.keys(scope.layer)[0]];
            scope.selectedDistrict = activeDistrict.uid;
          } else {
            activeDistrict = scope.layer.districts[scope.selectedDistrict];
          }

          var head = prepareTableHead(activeDistrict);
          var sortedIndicators = IndicatorSetHandling.sortIndicatorsAndListsFlat(scope.selectedIndicatorSet);
          var body = prepareTableBody(scope.layer, sortedIndicators, scope.selectedDistrict);
          element.find('table').html(head + body);
          $compile(element.find('table').contents())(scope);
        }
      }

      var selectedIndicatorSetWatcher = scope.$watch('selectedIndicatorSet', rerender, true);
      var selectedDistrictWatcher = scope.$watch('selectedDistrict', rerender);
      var layerWatcher = scope.$watch('layer', rerender, true);

      element.on('$destroy', function () {
        selectedIndicatorSetWatcher();
        selectedDistrictWatcher();
        layerWatcher();
      });
    }
  };
});
